import { createSlice } from "@reduxjs/toolkit";
import { IMainStepSlice } from "../../../models/freshman/mainStep";


const initialMainStepState: IMainStepSlice = {
    mainStep: undefined,
    mainSteps: undefined,
    keyValuePair: undefined,
};

const mainStepSlice = createSlice({
    name: "mainStep",
    initialState: initialMainStepState,
    reducers: {
        setMainSteps: (state, action: { payload: any }) => {
            state.mainSteps = action.payload;
        },
        setMainStep: (state, action: { payload: any }) => {
            state.mainStep = action.payload;
        },
        setKeyValuePair: (state, action: { payload: any }) => {
            state.keyValuePair = action.payload;
        }
    },
});

export const { setMainSteps, setMainStep, setKeyValuePair } = mainStepSlice.actions;

const mainStepReducer = mainStepSlice.reducer;

export type mainStepState = ReturnType<typeof mainStepReducer>;

export default mainStepReducer;
